import React, { createContext, useContext } from 'react';

interface ExperimentFlags {
  [key: string]: boolean;
}

export const ExperimentContext = createContext<ExperimentFlags>({});
export const useExperimentFlags = () => useContext(ExperimentContext);

interface ProviderProps {
  values: ExperimentFlags;
  children: React.ReactNode;
}

export const ExperimentProvider = ({ values, children }: ProviderProps) => (
  <ExperimentContext.Provider value={values}>
    {children}
  </ExperimentContext.Provider>
);
